<template>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{$t('Groups')}}</h4>
        <p class="card-description">
          <!--For displaying tabular data. <code>&lt;b-table&gt;</code> supports pagination, filtering, sorting, custom rendering, events, and asynchronous data.-->
        </p>
        <b-container fluid>
          <!-- User Interface controls -->
          <b-row>
            <b-col lg="4" class="my-1">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    :placeholder="$t('Type to Search')"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">{{$t('Clear')}}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-btn style="float:right;color:white" variant="light">{{$t('Add Group')}}</b-btn>
            </b-col>

          </b-row>

          <!-- Main table element -->
          <b-table
            show-empty
            hover
            responsive
            :items="$store.state.groups"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template v-slot:cell(name)="row">
              <b-link class="nav-link" :to="'/companies/'+$route.params.company+'/group/'+row.item.id">{{ row.item.name }} </b-link>
            </template>

            <template v-slot:cell(status)="row">
              <label :class="row.item.status === 'Active' ? 'text-success' : 'bg-danger btn-sm'" style="text-align: center;">{{ row.item.status }}</label>
            </template>

            <template v-slot:cell(actions)="row" >
              <b-button variant="primary" size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                {{$t('Edit')}}
              </b-button>
              <b-button variant="outline-dark" size="sm" @click="row.toggleDetails">
                {{$t('Remove')}}
              </b-button>
            </template>

            <template v-slot:row-details="row">
              <b-card>
                <ul>
                  <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                </ul>
              </b-card>
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            class="my-5"
          ></b-pagination>

        </b-container>
      </div>
    </div>

</template>

<script>
export default {
  data () {
    return {
      fields: [
        { key: 'name', label: this.$t('Name'), sortable: true, sortDirection: 'desc', class: 'text-left' },
        { key: 'userCount', label: this.$t('Users in Group'), sortable: false, class: 'text-center' },
        { key: 'category', label: this.$t('Category'), sortable: true, sortDirection: 'desc', class: 'text-center' },
        { key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      }
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  mounted () {
    // Set the initial number of items
    this.totalRows = this.$store.state.groups.length
    this.$store.dispatch('fetchGroups')
    // this.mapUsers()
  },
  methods: {
    info (item, index, button) {
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Groups.vue